const CR_OBLASTI = 'cr_oblasti';
const CR_JEMNEJSI = 'cr_jemnejsi';

export {
    CR_OBLASTI,
    CR_JEMNEJSI,
};
